module.exports = __webpack_public_path__ + "img/8.1b727851.jpg";